var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn_alert",
    d: "M12.8906 17.8125C12.8906 18.3303 12.4709 18.75 11.9531 18.75C11.4353 18.75 11.0156 18.3303 11.0156 17.8125C11.0156 17.2947 11.4353 16.875 11.9531 16.875C12.4709 16.875 12.8906 17.2947 12.8906 17.8125ZM12.8906 6.51562C12.8906 5.9978 12.4709 5.57812 11.9531 5.57812C11.4353 5.57812 11.0156 5.9978 11.0156 6.51562V14.5312C11.0156 15.0491 11.4353 15.4688 11.9531 15.4688C12.4709 15.4688 12.8906 15.0491 12.8906 14.5312V6.51562ZM20.4853 3.51471C18.2188 1.24823 15.2053 0 12 0C8.79474 0 5.78119 1.24823 3.51471 3.51471C1.24823 5.78119 0 8.79474 0 12C0 15.2053 1.24823 18.2188 3.51471 20.4853C5.78119 22.7518 8.79474 24 12 24C14.1943 24 16.3414 23.402 18.2091 22.2706C18.652 22.0023 18.7936 21.4259 18.5253 20.9832C18.2569 20.5402 17.6805 20.3987 17.2377 20.6669C15.663 21.6207 13.8517 22.125 12 22.125C6.41711 22.125 1.875 17.5829 1.875 12C1.875 6.41711 6.41711 1.875 12 1.875C17.5829 1.875 22.125 6.41711 22.125 12C22.125 13.9964 21.5314 15.9395 20.4082 17.6197C20.1204 18.05 20.2361 18.6323 20.6664 18.9201C21.0969 19.2079 21.6791 19.0922 21.9668 18.6617C23.2971 16.6723 24 14.3687 24 12C24 8.79474 22.7518 5.78119 20.4853 3.51471Z",
    fill: "#F7432B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAlert);
export default __webpack_public_path__ + "static/media/icn_alert.530425e96095e251a3c06975c354f23f.svg";
export { ForwardRef as ReactComponent };